<template>
  <bc-select v-model="$formValues[id]" :options="$controls[id].items">
  </bc-select>
</template>
<script>
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: Number,
    id: String,
  },
  computed: {
  },
  methods: {
  },
}
</script>